/**
 * Product Card LOP - JavaScript para funcionalidad de swatches
 * Versión: 4.0.0
 * Autor: LOP Development Team
 */

(function() {
  'use strict';

  if (window.__productCardLOPBundleLoaded) {
    return;
  }
  window.__productCardLOPBundleLoaded = true;

  const LOP_MAX_HANDLE_LEN = 255;

  function lopNormalizeHandle(raw) {
    if (raw == null || typeof raw !== 'string') return '';
    let h = raw.trim().replace(/^\s*["'[{]+/, '').replace(/["'}\]]+\s*$/, '');
    h = h.split(/[?#]/)[0].trim();
    if (!h || h.length > LOP_MAX_HANDLE_LEN) return '';
    return h;
  }

  function lopProductJsonUrl(handle) {
    const h = lopNormalizeHandle(handle);
    if (!h) return '';
    let root = '';
    try {
      if (typeof theme !== 'undefined' && theme.routes && theme.routes.root_url != null) {
        root = String(theme.routes.root_url);
      }
    } catch (e) {
      root = '';
    }
    const base = root.replace(/\/+$/, '');
    return `${base}/products/${encodeURIComponent(h)}.js`;
  }

  // Configuración
  const LOP_CONFIG = {
    maxSwatches: 5,
    navigationDelay: 300,
    loadingClass: 'loading',
    errorClass: 'error',
    hoverClass: 'hover'
  };

  // Clases CSS
  const LOP_CLASSES = {
    swatchesContainer: 'LOP-product-card-swatches-container',
    swatchItem: 'LOP-product-card-swatch-item',
    swatchLink: 'LOP-product-card-swatch-link',
    swatchImage: 'LOP-product-card-swatch-image',
    cardVariantSwatch: 'lop-card-variant-swatch',
    relatedThumb: 'product-card-related-thumb',
    relatedThumbActive: 'product-card-related-thumb--active'
  };

  /**
   * Clase principal para manejar Product Card LOP
   */
  class ProductCardLOP {
    constructor() {
      this.initialized = false;
      this.init();
    }

    /**
     * Inicializar la funcionalidad
     */
    init() {
      if (this.initialized) return;
      
      
      // Inicializar swatches existentes
      this.initSwatches();

      // Delegación global: actualizar tarjeta al clickear variante (desktop + mobile)
      this.bindCardSwatchClicks();
      
      // Observar cambios en el DOM para nuevos swatches
      this.observeDOM();
      
      // Verificar swatches después de la carga
      this.checkSwatchesAfterLoad();
      
      // Verificar y ocultar swatches fallback inmediatamente
      this.hideInvalidFallbackSwatches();
      
      // Cargar datos de productos faltantes después de un delay
      setTimeout(() => {
        this.loadMissingProductData();
        // Ocultar duplicados DESPUÉS de cargar todos los datos
        this.hideDuplicateSwatches();
      }, 1000);
      
      this.initialized = true;
    }

    /**
     * Inicializar swatches existentes
     */
    initSwatches() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      swatches.forEach((swatch, index) => {
        this.setupSwatch(swatch, index);
      });
    }

    /**
     * Configurar un swatch individual
     */
    setupSwatch(swatch, index) {
      if (!swatch.dataset.productHandle) {
        console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        return;
      }

      // Remover eventos existentes para evitar duplicados
      const newSwatch = swatch.cloneNode(true);
      swatch.parentNode.replaceChild(newSwatch, swatch);
      
      // Configurar eventos en el nuevo swatch
      this.addSwatchEvents(newSwatch, index);
      
    }

    /**
     * Añadir eventos a un swatch
     */
    addSwatchEvents(swatch, index) {
      const link = swatch.querySelector(`.${LOP_CLASSES.swatchLink}`);
      
      if (link) {
        // Evento de click
        link.addEventListener('click', (e) => {
          this.handleSwatchClick(e, swatch);
        });
        
        // Eventos de hover
        swatch.addEventListener('mouseenter', () => {
          this.handleSwatchHover(swatch, true);
        });
        
        swatch.addEventListener('mouseleave', () => {
          this.handleSwatchHover(swatch, false);
        });
        
        // Evento de focus para accesibilidad
        swatch.addEventListener('focus', () => {
          this.handleSwatchFocus(swatch);
        });
      }
    }

    /**
     * Delegación de clicks en swatches de tarjeta (custom.id + LOP swatches)
     */
    bindCardSwatchClicks() {
      if (this._cardSwatchClickBound) return;
      this._cardSwatchClickBound = true;

      document.addEventListener('click', (e) => {
        const relatedThumb = e.target.closest(`.${LOP_CLASSES.relatedThumb}`);
        if (relatedThumb) {
          e.preventDefault();
          e.stopPropagation();
          this.handleCardVariantClick(relatedThumb);
          return;
        }

        const lopSwatchItem = e.target.closest(`.${LOP_CLASSES.swatchItem}`);
        if (lopSwatchItem && e.target.closest(`.${LOP_CLASSES.swatchLink}`)) {
          e.preventDefault();
          e.stopPropagation();
          this.handleCardVariantClick(lopSwatchItem);
        }
      });
    }

    /**
     * Parsear cucardas serializadas desde data-lop-discount-badges
     */
    parseDiscountBadges(raw) {
      if (!raw || typeof raw !== 'string' || !raw.trim()) return [];

      return raw.split(';;').filter(Boolean).map((part) => {
        const segments = part.split('|');
        return {
          type: segments[0] || 'number',
          text: segments[1] || '',
          color: segments[2] || ''
        };
      }).filter((badge) => badge.text);
    }

    /**
     * Construir HTML de cucardas LOP
     */
    buildDiscountBadgesHtml(badges) {
      if (!Array.isArray(badges) || !badges.length) return '';

      return badges.map((badge) => {
        const modifier = badge.type === 'title' ? 'LOP-discount-badge--title' : 'LOP-discount-badge--number';
        const style = badge.color ? ` style="background-color: ${badge.color};"` : '';
        const text = String(badge.text)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
        return `<div class="LOP-discount-badge ${modifier}"${style}><span class="LOP-discount-text">${text}</span></div>`;
      }).join('');
    }

    /**
     * Actualizar cucardas de descuento en la tarjeta
     */
    updateDiscountBadges(productCard, payload) {
      const figure = productCard.querySelector('.product-card-image');
      if (!figure) return;

      const badges = payload.discountBadges || [];
      const badgesHtml = this.buildDiscountBadgesHtml(badges);
      let container = figure.querySelector('.LOP-discount-badges-container');

      if (!badgesHtml) {
        if (container) container.remove();
        return;
      }

      if (!container) {
        container = document.createElement('div');
        container.className = 'LOP-discount-badges-container';
        const imageLink = figure.querySelector('.product-card-image-link');
        if (imageLink) {
          figure.insertBefore(container, imageLink);
        } else {
          figure.appendChild(container);
        }
      }

      container.innerHTML = badgesHtml;
    }

    /**
     * Muestra u oculta la pastilla Envío gratis según el precio visible de la variante.
     */
    updateEnvioGratisBadge(productCard, payload) {
      const configEl = productCard.querySelector('[data-lop-envio-gratis-threshold]');
      if (!configEl) return;

      const threshold = parseInt(configEl.dataset.lopEnvioGratisThreshold, 10) || 0;
      const qualifies = threshold > 0 && payload.price > threshold;
      let badge = productCard.querySelector('.lop-envio-gratis-badge');

      if (!qualifies) {
        if (badge) badge.remove();
        return;
      }

      if (badge) return;

      badge = document.createElement('span');
      badge.className = 'lop-envio-gratis-badge';
      if (configEl.dataset.lopEnvioGratisBg) badge.style.background = configEl.dataset.lopEnvioGratisBg;
      if (configEl.dataset.lopEnvioGratisColor) badge.style.color = configEl.dataset.lopEnvioGratisColor;

      const icon = document.createElement('img');
      icon.className = 'lop-envio-gratis-badge__icon';
      icon.alt = '';
      icon.width = 20;
      icon.height = 14;
      icon.loading = 'lazy';
      if (configEl.dataset.lopEnvioGratisIcon) icon.src = configEl.dataset.lopEnvioGratisIcon;

      const label = document.createElement('span');
      label.className = 'lop-envio-gratis-badge__text';
      label.textContent = configEl.dataset.lopEnvioGratisText || 'Envío gratis';

      badge.appendChild(icon);
      badge.appendChild(label);

      const tax = productCard.querySelector('.LOP-product-price-without-taxes');
      if (tax) {
        tax.insertAdjacentElement('afterend', badge);
      } else {
        configEl.insertAdjacentElement('afterend', badge);
      }
    }

    /**
     * Obtener payload de variante desde data-lop-* o dataset del swatch
     */
    getSwatchPayload(swatchEl) {
      if (!swatchEl) return null;

      if (swatchEl.dataset.lopHandle) {
        const rawSecondary = swatchEl.dataset.lopSecondaryImages || '';
        return {
          handle: swatchEl.dataset.lopHandle,
          url: swatchEl.dataset.lopUrl,
          title: swatchEl.dataset.lopTitle,
          variantId: swatchEl.dataset.lopVariantId,
          customId: swatchEl.dataset.lopCustomId || '',
          image: swatchEl.dataset.lopImage,
          thumb: swatchEl.dataset.lopThumb,
          price: parseInt(swatchEl.dataset.lopPrice, 10) || 0,
          comparePrice: parseInt(swatchEl.dataset.lopComparePrice, 10) || 0,
          hasDiscount: swatchEl.dataset.lopHasDiscount === 'true',
          priceWithoutTax: parseInt(swatchEl.dataset.lopPriceWithoutTax, 10) || 0,
          secondaryImages: rawSecondary ? rawSecondary.split(',').filter(Boolean) : [],
          discountBadges: this.parseDiscountBadges(swatchEl.dataset.lopDiscountBadges || '')
        };
      }

      const handle = swatchEl.dataset.productHandle;
      if (!handle) return null;

      const link = swatchEl.querySelector(`.${LOP_CLASSES.swatchLink}`);
      const swatchImage = swatchEl.querySelector(`.${LOP_CLASSES.swatchImage}`);
      const imageSrc = swatchImage && swatchImage.src ? swatchImage.src : '';

      return {
        handle,
        url: link ? link.getAttribute('href') : `/products/${handle}`,
        title: swatchEl.dataset.tooltip || swatchEl.dataset.productColor || '',
        variantId: '',
        customId: '',
        image: imageSrc,
        thumb: imageSrc,
        price: 0,
        comparePrice: 0,
        hasDiscount: false,
        priceWithoutTax: 0,
        needsFetch: true,
        discountBadges: []
      };
    }

    /**
     * Formatear dinero usando utilidad del tema
     */
    formatMoney(cents) {
      const format = window.theme && window.theme.settings
        ? window.theme.settings.money_with_currency_format
        : '${{amount}}';
      if (typeof formatMoney === 'function') {
        return formatMoney(cents, format);
      }
      return `$${(cents / 100).toFixed(0)}`;
    }

    /**
     * Construir payload desde /products/{handle}.js
     */
    buildPayloadFromProductJson(product) {
      if (!product) return null;

      const variant = product.variants && product.variants.length
        ? (product.variants.find((v) => v.available) || product.variants[0])
        : null;

      const price = variant ? variant.price : product.price;
      const comparePrice = variant ? (variant.compare_at_price || 0) : (product.compare_at_price || 0);
      const hasDiscount = comparePrice > price;
      const image = product.featured_image || (product.images && product.images[0]) || '';

      // Imágenes secundarias: el endpoint .js devuelve product.images como array de strings
      const secondaryImages = Array.isArray(product.images)
        ? product.images.slice(1, 4).filter(Boolean)
        : [];

      return {
        handle: product.handle,
        url: `/products/${product.handle}`,
        title: product.title,
        variantId: variant ? String(variant.id) : '',
        customId: '',
        image,
        thumb: image,
        price,
        comparePrice: hasDiscount ? comparePrice : price,
        hasDiscount,
        priceWithoutTax: Math.round(price * 100 / 121),
        secondaryImages,
        discountBadges: []
      };
    }

    /**
     * Marcar swatch activo dentro de la tarjeta
     */
    setActiveSwatch(productCard, activeSwatch) {
      if (!productCard || !activeSwatch) return;

      productCard.querySelectorAll(`.${LOP_CLASSES.relatedThumb}`).forEach((thumb) => {
        thumb.classList.remove(LOP_CLASSES.relatedThumbActive);
      });

      productCard.querySelectorAll(`.${LOP_CLASSES.swatchItem}`).forEach((item) => {
        item.dataset.isCurrentProduct = 'false';
        item.classList.remove('lop-card-variant-swatch--active');
      });

      if (activeSwatch.classList.contains(LOP_CLASSES.relatedThumb)) {
        activeSwatch.classList.add(LOP_CLASSES.relatedThumbActive);
      }

      if (activeSwatch.classList.contains(LOP_CLASSES.swatchItem)) {
        activeSwatch.dataset.isCurrentProduct = 'true';
        activeSwatch.classList.add('lop-card-variant-swatch--active');
      }
    }

    /**
     * Actualizar DOM de la tarjeta de producto con datos de la variante
     */
    updateProductCard(productCard, payload) {
      if (!productCard || !payload) return;

      const primaryImage = productCard.querySelector('.product-primary-image');
      if (primaryImage && payload.image) {
        primaryImage.setAttribute('src', payload.image);
        primaryImage.setAttribute('srcset', `${payload.image} 770w`);
        primaryImage.setAttribute('alt', payload.title || '');
        if (primaryImage.dataset) {
          primaryImage.dataset.srcset = `${payload.image} 770w`;
        }
      }

      const secondaryImgEls = productCard.querySelectorAll('.product-secondary-image');
      const newSecondaryUrls = payload.secondaryImages || [];
      const figure = productCard.querySelector('.product-card-image');

      secondaryImgEls.forEach((img, index) => {
        img.classList.remove('hover');
        const newSrc = newSecondaryUrls[index];
        if (newSrc) {
          img.setAttribute('src', newSrc);
          img.setAttribute('srcset', `${newSrc} 770w`);
          if (img.dataset) img.dataset.src = newSrc;
          img.style.display = '';
        } else {
          img.style.display = 'none';
        }
      });

      // Activar/desactivar hover de figura según si hay imagen secundaria disponible
      if (figure) {
        if (newSecondaryUrls.length > 0) {
          figure.classList.add('thb-hover');
        } else {
          figure.classList.remove('thb-hover');
        }
      }

      productCard.querySelectorAll('.product-secondary-images-nav li').forEach((li) => {
        li.classList.remove('active');
      });

      const titleLink = productCard.querySelector('.product-card-title');
      if (titleLink) {
        titleLink.textContent = payload.title || '';
        titleLink.setAttribute('href', payload.url || '#');
        titleLink.setAttribute('title', payload.title || '');
      }

      const priceContainer = productCard.querySelector('.LOP-product-price-wrapper .product-price');
      if (priceContainer) {
        if (payload.hasDiscount) {
          priceContainer.innerHTML = `
            <span class="product-price--regular product-price--strike">${this.formatMoney(payload.comparePrice)}</span>
            <span class="product-price--sale">${this.formatMoney(payload.price)}</span>
          `;
        } else {
          priceContainer.innerHTML = `
            <span class="product-price--regular">${this.formatMoney(payload.price)}</span>
          `;
        }
      }

      this.updateDiscountBadges(productCard, payload);
      this.updateEnvioGratisBadge(productCard, payload);

      const installmentOptions = productCard.querySelector('product-installment-options');
      if (installmentOptions && payload.price > 0) {
        const installmentsCount = parseInt(installmentOptions.dataset.installments, 10) || 6;
        const installmentAmount = Math.round(payload.price / installmentsCount);
        const installmentFormatted = this.formatMoney(installmentAmount);
        const interestFree = installmentOptions.dataset.interestFree === 'true';
        const installmentEl = installmentOptions.querySelector('.installment-option');
        if (installmentEl) {
          installmentEl.textContent = `${installmentsCount} cuotas de ${installmentFormatted}${interestFree ? ' sin interes' : ''}`;
        }
      }

      const installmentsEl = productCard.querySelector('.product-installments');
      if (installmentsEl && payload.price > 0) {
        const installmentsCount = parseInt(installmentsEl.dataset.installments, 10) || 6;
        const installmentAmount = Math.round(payload.price / installmentsCount);
        const installmentFormatted = this.formatMoney(installmentAmount);
        const installmentText = installmentsEl.querySelector('.installment-text');
        const sinInteres = installmentText && installmentText.textContent.includes('sin interés') ? ' sin interés' : '';
        if (installmentText) {
          installmentText.textContent = `${installmentsCount} cuotas de ${installmentFormatted}${sinInteres}`;
        }
        installmentsEl.dataset.price = String(payload.price);
      }

      if (payload.priceWithoutTax > 0) {
        const taxFormatted = this.formatMoney(payload.priceWithoutTax);
        const taxValue = productCard.querySelector('.LOP-product-price-without-taxes-value');
        if (taxValue) {
          taxValue.textContent = taxFormatted;
        }
        const taxDesktop = productCard.querySelector('.LOP-price-label-desktop');
        const taxMobile = productCard.querySelector('.LOP-price-label-mobile');
        if (taxDesktop) {
          taxDesktop.textContent = `Precio sin impuestos nacionales: ${taxFormatted}`;
        }
        if (taxMobile) {
          taxMobile.textContent = `Precio sin imp: ${taxFormatted}`;
        }
      }

      const swatchMore = productCard.querySelector('.LOP-product-card-swatch-more');
      if (swatchMore && payload.url) {
        swatchMore.setAttribute('href', payload.url);
      }

      const linkSelectors = [
        '.product-card__full-link',
        '.product-card-image-link',
        '.product-card--view-details'
      ];

      linkSelectors.forEach((selector) => {
        productCard.querySelectorAll(selector).forEach((link) => {
          link.setAttribute('href', payload.url || '#');
          if (link.classList.contains('product-card-image-link')) {
            link.setAttribute('title', payload.title || '');
          }
        });
      });

      const quickView = productCard.querySelector('quick-view');
      if (quickView) {
        if (payload.variantId) {
          quickView.setAttribute('data-product-id', payload.variantId);
        }
        quickView.setAttribute('data-product-handle', payload.handle || '');
      }

      const addToCart = productCard.querySelector('.product-card--add-to-cart-button');
      if (addToCart) {
        if (payload.variantId) {
          addToCart.setAttribute('data-product-id', payload.variantId);
        }
        addToCart.setAttribute('data-product-handle', payload.handle || '');
      }

      if (payload.customId) {
        productCard.setAttribute('data-custom-id', payload.customId);
        productCard.setAttribute('data-product-handle', payload.handle || '');
        productCard.setAttribute('data-product-image', payload.thumb || payload.image || '');
        productCard.setAttribute('data-product-url', payload.url || '');
        productCard.setAttribute('data-product-title', payload.title || '');
      }

      productCard.classList.add('lop-card-variant-updated');
      productCard.dispatchEvent(new CustomEvent('lop:card-variant-change', {
        bubbles: true,
        detail: { payload }
      }));
    }

    /**
     * Click en variante: actualizar tarjeta sin ir a PDP
     */
    async handleCardVariantClick(swatchEl) {
      const productCard = swatchEl.closest('product-card');
      if (!productCard) return;

      if (swatchEl.classList.contains(LOP_CLASSES.relatedThumbActive)
        || swatchEl.dataset.isCurrentProduct === 'true') {
        return;
      }

      swatchEl.classList.add(LOP_CONFIG.loadingClass);

      try {
        let payload = this.getSwatchPayload(swatchEl);

        if (payload && payload.needsFetch && payload.handle) {
          const productData = await this.loadProductData(payload.handle);
          payload = this.buildPayloadFromProductJson(productData);
        }

        if (!payload || !payload.handle) {
          throw new Error('Payload de variante inválido');
        }

        this.updateProductCard(productCard, payload);
        this.setActiveSwatch(productCard, swatchEl);
      } catch (error) {
        console.error('Product Card LOP: Error al cambiar variante:', error);
        swatchEl.classList.add(LOP_CONFIG.errorClass);
      } finally {
        swatchEl.classList.remove(LOP_CONFIG.loadingClass);
      }
    }

    /**
     * Manejar click en swatch LOP (compatibilidad con setupSwatch)
     */
    handleSwatchClick(e, swatch) {
      e.preventDefault();
      e.stopPropagation();
      this.handleCardVariantClick(swatch);
    }

    /**
     * Manejar hover en swatch
     */
    handleSwatchHover(swatch, isEntering) {
      if (isEntering) {
        swatch.classList.add(LOP_CONFIG.hoverClass);
        
        // Aquí podrías implementar la lógica para cambiar la imagen del product card
        const productHandle = swatch.dataset.productHandle;
        if (productHandle) {
          // Buscar el product card padre
          const productCard = swatch.closest('product-card');
          if (productCard) {
            // Aquí podrías cambiar la imagen del product card
          }
        }
      } else {
        swatch.classList.remove(LOP_CONFIG.hoverClass);
      }
    }

    /**
     * Manejar focus en swatch
     */
    handleSwatchFocus(swatch) {
      const productHandle = swatch.dataset.productHandle;
      if (productHandle) {
      }
    }

    /**
     * Observar cambios en el DOM
     */
    observeDOM() {
      const observer = new MutationObserver((mutations) => {
        let shouldCheck = false;
        
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && node.classList.contains(LOP_CLASSES.swatchItem)) {
                  shouldCheck = true;
                } else if (node.querySelector && node.querySelector(`.${LOP_CLASSES.swatchItem}`)) {
                  shouldCheck = true;
                }
              }
            });
          }
        });
        
        if (shouldCheck) {
          setTimeout(() => {
            this.checkForNewSwatches();
          }, 100);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    /**
     * Verificar nuevos swatches
     */
    checkForNewSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const initializedSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}[data-lop-initialized]`);
      
      if (allSwatches.length > initializedSwatches.length) {
        
        allSwatches.forEach((swatch, index) => {
          if (!swatch.hasAttribute('data-lop-initialized')) {
            this.setupSwatch(swatch, index);
            swatch.setAttribute('data-lop-initialized', 'true');
          }
        });
      }
    }

    /**
     * Verificar swatches después de la carga
     */
    checkSwatchesAfterLoad() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            this.checkForNewSwatches();
          }, 500);
        });
      } else {
        setTimeout(() => {
          this.checkForNewSwatches();
        }, 500);
      }
    }

    /**
     * Verificar que todos los swatches estén funcionando
     */
    verifyAllSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      allSwatches.forEach((swatch, index) => {
        if (swatch.dataset.productHandle) {
          // Asegurar que el swatch sea clickeable
          swatch.style.pointerEvents = 'auto';
          swatch.style.cursor = 'pointer';
          
          // Verificar que tenga los atributos necesarios
          if (!swatch.hasAttribute('data-lop-verified')) {
            swatch.setAttribute('data-lop-verified', 'true');
          }
        } else {
          console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        }
      });
      
      return allSwatches.length;
    }

    /**
     * Función de utilidad para debug
     */
    debug() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      return {
        config: LOP_CONFIG,
        classes: LOP_CLASSES,
        totalSwatches: allSwatches.length,
        swatches: Array.from(allSwatches).map((swatch, index) => ({
          index,
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          tooltip: swatch.dataset.tooltip,
          isCurrent: swatch.dataset.isCurrentProduct
        }))
      };
    }

    /**
     * Verificar productos relacionados en un product card específico
     */
    debugProductCard(productCard) {
      if (!productCard) {
        return { error: 'No se proporcionó product card' };
      }

      const swatches = productCard.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const productTitle = productCard.querySelector('.product-card-title')?.textContent || 'Sin título';
      
      return {
        productTitle,
        totalSwatches: swatches.length,
        swatches: Array.from(swatches).map((swatch, index) => ({
          index: index + 1,
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          tooltip: swatch.dataset.tooltip,
          url: swatch.dataset.productHandle ? `/products/${swatch.dataset.productHandle}` : null
        }))
      };
    }

    /**
     * Verificar todos los product cards en la página
     */
    debugAllProductCards() {
      const productCards = document.querySelectorAll('product-card');
      
      return {
        total: productCards.length,
        cards: Array.from(productCards).map((card, index) => {
        const title = card.querySelector('.product-card-title')?.textContent || 'Sin título';
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        
          return {
            index: index + 1,
            title,
            totalSwatches: swatches.length,
            swatchHandles: Array.from(swatches).map(s => s.dataset.productHandle)
          };
        })
      };
    }

    /**
     * Verificar si los productos del agrupador existen
     */
    debugAgrupadorProducts(agrupadorString) {
      if (!agrupadorString) {
        return { error: 'No se proporcionó agrupador' };
      }

      try {
        // Parsear el JSON del agrupador
        const agrupador = JSON.parse(agrupadorString);
        console.log(`Product Card LOP: Agrupador parseado - ${agrupador.length} productos`);
        
        agrupador.forEach((handle, index) => {
          console.log(`Producto ${index + 1}: ${handle}`);
          
          // Verificar si el producto existe haciendo una petición
          fetch(`/products/${handle}.js`)
            .then(response => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(`Producto no encontrado: ${handle}`);
              }
            })
            .then(product => {
              console.log(`  ✓ ${handle} - ${product.title}`);
            })
            .catch(error => {
              console.log(`  ✗ ${handle} - ${error.message}`);
            });
        });
      } catch (error) {
        console.error('Product Card LOP: Error parseando agrupador:', error);
      }
    }

    /**
     * Cargar datos de productos dinámicamente
     */
    loadProductData(handle) {
      let cleanHandle = lopNormalizeHandle(handle);
      if (!cleanHandle) {
        return Promise.resolve(null);
      }

      if (cleanHandle.length > 50 || (cleanHandle.includes('remera-') && cleanHandle.includes('buzo-'))) {
        const possibleHandles = cleanHandle.split(/(?=remera-|buzo-|zapatillas-|calzado-|rbk)/);
        if (possibleHandles.length > 1) {
          cleanHandle = lopNormalizeHandle(possibleHandles[0]);
        }
      }

      const url = lopProductJsonUrl(cleanHandle);
      if (!url) {
        return Promise.resolve(null);
      }

      return fetch(url)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(`Producto no encontrado: ${cleanHandle}`);
          }
        })
        .catch(error => {
          console.error(`Product Card LOP: Error cargando ${cleanHandle}:`, error);
          return null;
        });
    }

    /**
     * Actualizar swatch con datos del producto
     */
    updateSwatchWithProductData(swatch, productData) {
      if (!productData) return;

      // Actualizar imagen si está disponible
      if (productData.featured_image) {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        if (swatchImage) {
          // Si es un div (fallback), convertirlo a img
          if (swatchImage.tagName === 'DIV') {
            const newImg = document.createElement('img');
            newImg.src = productData.featured_image;
            newImg.alt = productData.title;
            newImg.className = 'LOP-product-card-swatch-image';
            newImg.loading = 'lazy';
            swatchImage.parentNode.replaceChild(newImg, swatchImage);
          } else {
            // Si ya es una img, actualizar src
            swatchImage.src = productData.featured_image;
            swatchImage.alt = productData.title;
          }
        }
      }

      // Actualizar tooltip
      if (productData.title) {
        swatch.dataset.tooltip = productData.title;
      }

      // Actualizar color si está disponible
      if (productData.options && productData.options.length > 0) {
        const firstOption = productData.options[0];
        if (firstOption.values && firstOption.values.length > 0) {
          swatch.dataset.productColor = firstOption.values[0];
        }
      }

      // Marcar como cargado exitosamente
      swatch.classList.add('LOP-swatch-loaded');
      swatch.classList.remove('LOP-product-card-swatch-fallback');

    }

    /**
     * Ocultar swatch fallback cuando no tiene imagen válida
     */
    hideFallbackSwatch(swatch) {
      if (!swatch) return;
      
      // Añadir clase para ocultar el swatch
      swatch.classList.add('LOP-swatch-hidden');
      swatch.style.display = 'none';
      
      // Remover eventos para evitar interacciones
      swatch.style.pointerEvents = 'none';
      swatch.style.cursor = 'default';
      
    }

    /**
     * Mostrar swatch válido cuando se confirma que tiene imagen
     */
    showValidSwatch(swatch) {
      if (!swatch) return;
      
      // Remover clases de ocultación
      swatch.classList.remove('LOP-swatch-hidden');
      swatch.style.display = '';
      
      // Restaurar eventos
      swatch.style.pointerEvents = 'auto';
      swatch.style.cursor = 'pointer';
      
    }

    /**
     * Ocultar swatches fallback inválidos inmediatamente
     */
    hideInvalidFallbackSwatches() {
      
      const fallbackSwatches = document.querySelectorAll('.LOP-product-card-swatch-fallback');
      let hiddenCount = 0;
      
      fallbackSwatches.forEach((swatch) => {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        // Verificar si es un swatch de carga (gris con texto)
        if (swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-loading')) {
          // Verificar si tiene el atributo data-needs-loading
          if (swatch.dataset.needsLoading === 'true') {
            this.hideFallbackSwatch(swatch);
            hiddenCount++;
          }
        }
      });
      
    }

    /**
     * Ocultar solo swatches duplicados DENTRO de cada tarjeta de producto (no global)
     * Cada tarjeta mantiene sus propios swatches independientemente de otras tarjetas
     */
    hideDuplicateSwatches() {
      // Procesar cada tarjeta de producto independientemente
      const productCards = document.querySelectorAll('product-card, .product-card');
      let totalHiddenCount = 0;
      
      productCards.forEach(card => {
        const seenHandles = new Set();
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        
        swatches.forEach(swatch => {
          const swatchHandle = swatch.dataset.productHandle;
          if (!swatchHandle) return;
          
          // Si ya vimos este handle EN ESTA TARJETA, ocultar este swatch (es un duplicado)
          if (seenHandles.has(swatchHandle)) {
            swatch.style.display = 'none';
            swatch.classList.add('LOP-swatch-duplicate-hidden');
            totalHiddenCount++;
            return;
          }
          
          // Marcar este handle como visto para esta tarjeta
          seenHandles.add(swatchHandle);
        });
      });
      
    }

    /**
     * Cargar datos de productos para swatches que no están en all_products
     */
    loadMissingProductData() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      let loadedCount = 0;
      let hiddenCount = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        if (handle) {
          // Verificar si el swatch tiene datos básicos
          const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
          const hasImage = swatchImage && swatchImage.src && !swatchImage.src.includes('placeholder');
          const hasText = swatchImage && swatchImage.textContent && swatchImage.textContent.includes('Ver');
          
          // Verificar si es un swatch fallback (gris con texto)
          const isFallback = swatch.classList.contains('LOP-product-card-swatch-fallback') || 
                           (swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-loading'));
          
          if (isFallback || !hasImage || hasText) {
            
            // Cargar datos del producto
            this.loadProductData(handle).then(productData => {
              if (productData && productData.available && productData.featured_image) {
                this.updateSwatchWithProductData(swatch, productData);
                this.showValidSwatch(swatch);
                loadedCount++;
              } else {
                // Mantener oculto (ya está oculto por defecto)
                hiddenCount++;
              }
            }).catch(error => {
              // Mantener oculto (ya está oculto por defecto)
              hiddenCount++;
            });
          }
        }
      });
      
    }

    /**
     * Verificar estado del fallback y swatches
     */
    debugFallbackStatus() {
      console.log('Product Card LOP: Verificando estado del fallback...');
      
      const productCards = document.querySelectorAll('product-card');
      let totalCards = 0;
      let cardsWithAgrupador = 0;
      let cardsWithSwatches = 0;
      let cardsWithFallback = 0;
      
      productCards.forEach((card, index) => {
        const title = card.querySelector('.product-card-title')?.textContent || 'Sin título';
        const swatches = card.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        const debugInfo = card.querySelector('[style*="background: #f0f0f0"]');
        
        totalCards++;
        
        if (debugInfo) {
          cardsWithAgrupador++;
          
          if (swatches.length > 0) {
            cardsWithSwatches++;
            
            // Verificar si son swatches de fallback
            const fallbackSwatches = card.querySelectorAll('.LOP-product-card-swatch-item[data-product-color="Variante"]');
            if (fallbackSwatches.length > 0) {
              cardsWithFallback++;
              console.log(`  Card ${index + 1}: "${title}" - ${swatches.length} swatches (${fallbackSwatches.length} fallback)`);
            } else {
              console.log(`  Card ${index + 1}: "${title}" - ${swatches.length} swatches (normales)`);
            }
          } else {
            console.log(`  Card ${index + 1}: "${title}" - 0 swatches`);
          }
        } else {
          console.log(`  Card ${index + 1}: "${title}" - Sin agrupador`);
        }
      });
      
      console.log(`Product Card LOP: Resumen:`);
      console.log(`  Total cards: ${totalCards}`);
      console.log(`  Cards con agrupador: ${cardsWithAgrupador}`);
      console.log(`  Cards con swatches: ${cardsWithSwatches}`);
      console.log(`  Cards con fallback: ${cardsWithFallback}`);
      
      return {
        totalCards,
        cardsWithAgrupador,
        cardsWithSwatches,
        cardsWithFallback
      };
    }

    /**
     * Verificar estado actual de los swatches
     */
    checkCurrentSwatchStatus() {
      console.log('Product Card LOP: Verificando estado actual de swatches...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let fallbackSwatches = 0;
      let normalSwatches = 0;
      let emptySwatches = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (swatchImage) {
          if (swatchImage.tagName === 'DIV' && swatchImage.textContent.includes('Ver')) {
            fallbackSwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - FALLBACK (necesita carga)`);
          } else if (swatchImage.tagName === 'IMG' && swatchImage.src) {
            normalSwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - NORMAL (con imagen)`);
          } else {
            emptySwatches++;
            console.log(`  Swatch ${index + 1}: ${handle} - VACÍO`);
          }
        } else {
          emptySwatches++;
          console.log(`  Swatch ${index + 1}: ${handle} - SIN IMAGEN`);
        }
      });
      
      console.log(`Product Card LOP: Resumen de swatches:`);
      console.log(`  Total: ${swatches.length}`);
      console.log(`  Fallback (necesitan carga): ${fallbackSwatches}`);
      console.log(`  Normales (con imagen): ${normalSwatches}`);
      console.log(`  Vacíos: ${emptySwatches}`);
      
      return {
        total: swatches.length,
        fallback: fallbackSwatches,
        normal: normalSwatches,
        empty: emptySwatches
      };
    }

    /**
     * Forzar carga de datos para todos los swatches de fallback
     */
    forceLoadAllFallbackSwatches() {
      console.log('Product Card LOP: Forzando carga de todos los swatches de fallback...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let loadedCount = 0;
      let hiddenCount = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (handle && swatchImage && swatchImage.tagName === 'DIV' && swatchImage.textContent.includes('Ver')) {
          console.log(`Product Card LOP: Cargando datos forzados para ${handle}`);
          
          this.loadProductData(handle).then(productData => {
            if (productData && productData.available && productData.featured_image) {
              console.log(`Product Card LOP: Datos cargados exitosamente para ${handle} - ${productData.title}`);
              this.updateSwatchWithProductData(swatch, productData);
              this.showValidSwatch(swatch);
              loadedCount++;
            } else {
              console.log(`Product Card LOP: Producto ${handle} no disponible o sin imagen, manteniendo oculto`);
              // Mantener oculto (ya está oculto por defecto)
              hiddenCount++;
            }
          }).catch(error => {
            console.log(`Product Card LOP: Error cargando ${handle}, manteniendo oculto:`, error);
            // Mantener oculto (ya está oculto por defecto)
            hiddenCount++;
          });
        }
      });
      
      console.log(`Product Card LOP: Iniciada carga forzada de ${loadedCount} productos, ocultados ${hiddenCount} swatches`);
      return { loaded: loadedCount, hidden: hiddenCount };
    }

    /**
     * Verificar formato de metafields y handles
     */
    debugMetafieldFormat() {
      console.log('🔍 ===== DEBUG LOP HANDLES =====');
      
      // Obtener información de los divs de debug de Liquid
      const debugDivs = document.querySelectorAll('.LOP-debug-handles');
      console.log(`📦 Encontrados ${debugDivs.length} productos con debug info`);
      
      debugDivs.forEach((debugDiv, productIndex) => {
        const productHandle = debugDiv.dataset.product;
        const handlesString = debugDiv.dataset.handles;
        console.log(`\n📌 Producto ${productIndex + 1}: ${productHandle}`);
        console.log(`   Handles raw string: "${handlesString}"`);
        console.log(`   Contenido div:`, debugDiv.textContent.trim());
      });
      
      // Obtener todos los swatches
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const handles = Array.from(swatches).map(swatch => swatch.dataset.productHandle);
      
      console.log(`\n🎨 Total de swatches encontrados: ${swatches.length}`);
      console.log(`📋 Handles completos:`, handles);
      
      // Detectar duplicados
      const handleCounts = {};
      handles.forEach(handle => {
        if (handle) {
          handleCounts[handle] = (handleCounts[handle] || 0) + 1;
        }
      });
      
      const duplicates = Object.entries(handleCounts).filter(([_, count]) => count > 1);
      
      if (duplicates.length > 0) {
        console.warn('\n⚠️ HANDLES DUPLICADOS DETECTADOS:');
        duplicates.forEach(([handle, count]) => {
          console.warn(`   ❌ "${handle}" aparece ${count} veces`);
        });
      } else {
        console.log('\n✅ No se detectaron handles duplicados');
      }
      
      // Analizar cada handle
      console.log('\n📊 Análisis detallado de handles:');
      handles.forEach((handle, index) => {
        if (handle) {
          const cleanHandle = handle.trim();
          const isConcatenated = cleanHandle.length > 50 || 
                                (cleanHandle.includes('short-') && cleanHandle.lastIndexOf('short-') !== cleanHandle.indexOf('short-')) ||
                                (cleanHandle.includes('remera-') && cleanHandle.lastIndexOf('remera-') !== cleanHandle.indexOf('remera-')) ||
                                (cleanHandle.includes('rbk') && cleanHandle.split('rbk').length > 2);
          
          const isDuplicate = handleCounts[cleanHandle] > 1;
          
          console.log(`   ${index + 1}. Handle: "${cleanHandle}"`);
          console.log(`      - Longitud: ${cleanHandle.length} caracteres`);
          console.log(`      - ¿Concatenado?: ${isConcatenated ? '❌ SÍ' : '✅ NO'}`);
          console.log(`      - ¿Duplicado?: ${isDuplicate ? '❌ SÍ (' + handleCounts[cleanHandle] + ' veces)' : '✅ NO'}`);
          
          if (isConcatenated) {
            console.warn(`      ⚠️ Este handle parece estar concatenado!`);
          }
        }
      });
      
      console.log('\n🔍 ===== FIN DEBUG =====\n');
      
      return {
        totalHandles: handles.length,
        uniqueHandles: Object.keys(handleCounts).length,
        duplicates: duplicates.length,
        duplicateDetails: duplicates,
        validHandles: handles.filter(h => h && h.trim().length < 50).length,
        concatenatedHandles: handles.filter(h => h && h.trim().length > 50).length
      };
    }

    /**
     * Verificar formato de metafields desde JavaScript
     */
    debugMetafieldFormatFromJS() {
      console.log('Product Card LOP: Verificando formato de metafields desde JS...');
      
      // Buscar elementos de debug en el DOM
      const debugElements = document.querySelectorAll('[style*="display: none"]');
      let debugInfo = null;
      
      debugElements.forEach(element => {
        if (element.textContent.includes('Debug Agrupador Original:')) {
          debugInfo = element.textContent;
        }
      });
      
      if (debugInfo) {
        console.log('Product Card LOP: Información de debug encontrada:', debugInfo);
        
        // Extraer información específica
        const originalMatch = debugInfo.match(/Debug Agrupador Original: ([^\n]+)/);
        const cleanMatch = debugInfo.match(/Debug Agrupador Clean: ([^\n]+)/);
        const handlesMatch = debugInfo.match(/Debug Handles Encontrados: ([^\n]+)/);
        
        if (originalMatch) {
          console.log('Product Card LOP: Formato original:', originalMatch[1].trim());
        }
        if (cleanMatch) {
          console.log('Product Card LOP: Formato limpio:', cleanMatch[1].trim());
        }
        if (handlesMatch) {
          console.log('Product Card LOP: Handles encontrados:', handlesMatch[1].trim());
        }
      } else {
        console.log('Product Card LOP: No se encontró información de debug en el DOM');
      }
      
      return debugInfo;
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.productCardLOPInstance = new ProductCardLOP();
    });
  } else {
    window.productCardLOPInstance = new ProductCardLOP();
  }

  // Exponer para debugging
  window.ProductCardLOP = ProductCardLOP;
  
  // Función global para debugging
  window.debugProductCardLOP = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debug();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug de product cards específicos
  window.debugProductCard = function(productCard) {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugProductCard(productCard);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug de todos los product cards
  window.debugAllProductCards = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugAllProductCards();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para verificar productos del agrupador
  window.debugAgrupadorProducts = function(agrupadorString) {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.debugAgrupadorProducts(agrupadorString);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para cargar datos de productos faltantes
  window.loadMissingProductData = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.loadMissingProductData();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para cargar datos de un producto específico
  window.loadProductData = function(handle) {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.loadProductData(handle);
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return Promise.reject('Instancia no encontrada');
    }
  };

  // Función para verificar estado del fallback
  window.debugFallbackStatus = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugFallbackStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar estado actual de swatches
  window.checkCurrentSwatchStatus = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.checkCurrentSwatchStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para forzar carga de swatches de fallback
  window.forceLoadAllFallbackSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.forceLoadAllFallbackSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar formato de metafields
  window.debugMetafieldFormat = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugMetafieldFormat();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar formato de metafields desde JS
  window.debugMetafieldFormatFromJS = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugMetafieldFormatFromJS();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para ocultar swatches duplicados
  window.hideDuplicateSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.hideDuplicateSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

})(); 
